import { Navigate, Outlet } from "react-router-dom";

import { ROUTES } from "@/constants/routes.constants";
import { useUser } from "@/context/user-provider";

import { Loading } from "@/components/module/Loading";

export const ProtectedRoute: React.FC = () => {
  const { isAuthenticated, accessLoading } = useUser();

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  if (accessLoading) {
    return <Loading />;
  }

  return <Outlet />;
};
